import { createSiteAllowlistFlag } from "@/utils/siteAllowlistFlag";

const textComposerRcsRichCheck = createSiteAllowlistFlag(
  import.meta.env.VITE_FF_TEXT_COMPOSER_RCS_RICH,
  import.meta.env.VITE_FF_TEXT_COMPOSER_RCS_RICH_SITES,
);

/** RCS Rich: 3,072-char body limit and suggested-action pills. */
export const isTextComposerRcsRichEnabledForSite = (
  siteId: string | undefined,
): boolean => textComposerRcsRichCheck(siteId);
